import { all, fork } from 'redux-saga/effects';

import watchDeliveryRequest from './deliveryRequest';
import watchThirdsAuthorizationRequest from './thirdsAuthorizationRequest';
import watchThirdDeleteRequest from './thirdsDeleteRequest';
import watchThirdRequest from './thirdsRequest';

function* deliverySagas() {
  yield all([
    fork(watchDeliveryRequest),
    fork(watchThirdRequest),
    fork(watchThirdDeleteRequest),
    fork(watchThirdsAuthorizationRequest),
  ]);
}

export default deliverySagas;
